// 해지 사유 "기타" 코드값 — 이 코드를 선택했을 때만 자유입력 textarea를 보여준다(SubscriptionManagePage.tsx
// 가 ReasonSelectModal에 넘김).
// 선택지 목록·라벨 자체는 더 이상 여기 하드코딩하지 않는다 — Zeus 공통코드(G01_CANCEL_REASON,
// 2026-09-17 전환, 환불 사유와 동일 패턴)에서 billingApi.getCancelReasons()로 조회한다.
export const CANCEL_REASON_ETC_CODE = 'ETC';
